import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { distributorPageData, distributorFAQs } from "./distributordata";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForDistributorManagement() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <div className="bg-slate-50 min-h-screen">
      <BazAIHelmet
        title="Distributor Management Software — Scale Your Distribution Network with AI"
        description="EkkBaz AI Distributor Management helps you onboard distributors in 48 hours, monitor performance in real time, and grow distribution revenue by 50% — without adding headcount."
        keywords="distributor management software, distribution network management, distributor onboarding, territory management AI, distribution analytics, wholesale distribution software"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/product/distributor`}
        productName="Distributor Management"
        faqItems={distributorFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Distributor Management"
        subtitle="Onboard distributors in 48 hours, monitor performance in real time, and scale distribution revenue by 50% — all from one intelligent platform."
        from="distributor"
      />
      <EnhancedPageLayout {...distributorPageData} />
      <UpdateFooter />
    </div>
  );
}
